import React,{useContext} from 'react';
import proyectoContext from '../../context/proyectos/proyectoContext';
import TareaContext from '../../context/tareas/tareaContext';


const Proyecto = ({proyecto}) => {
    //obtener el state de poryectos
    const proyectosContext = useContext(proyectoContext);
    const {proyectoActual}= proyectosContext; 

    //Obtener la funcion del context de tarea
    const TareasContext = useContext(TareaContext);
    const {obtenerTareas}= TareasContext;


    //funcion para agregar el pryecto acual
    const seleccionarProyecto=id=>{
        proyectoActual(id); //fijar un proyecto actual
        obtenerTareas(id); //filtrar las taraeas cuado se de click
    }

    return ( 
        <li>
            <button
                type="button"
                className="btn btn-blank"
                onClick={()=>seleccionarProyecto(proyecto._id)}/*  se cambia id por _id cuando el back esta listo porque así viene de la base de datos */
            >{proyecto.nombre}</button>
        </li>
     );
}
 
export default Proyecto;